export default __webpack_public_path__ + "testimonials-quote-light.faa39287.svg";